import {
	ButtonBase,
	FontIconName,
	Icon
} from "client/Components";
import {
	ReactElement
} from "react";
import { useCallbackWithoutArguments } from "client/Hooks";
import classNames from "classnames";
import styles from "./SelectionCard.module.less";
import { isNotNil } from "client/Misc/utils";

export type SelectionCardProps = {
	icon?: FontIconName;
	title: string;
	description: string;
	isSelected: boolean;
	onClick: () => void;
	onDoubleClick: () => void;
	trackingId: string;
};

export const SelectionCard = (props: SelectionCardProps): ReactElement => {
	const {
		icon,
		title,
		description,
		isSelected,
		onClick: onClickFromProps,
		onDoubleClick: onDoubleClickFromProps,
		trackingId
	} = props;

	const onClick: () => void = useCallbackWithoutArguments(onClickFromProps);
	const onDoubleClick: () => void = useCallbackWithoutArguments(onDoubleClickFromProps);

	return (
		<ButtonBase
			className={classNames(
				styles.root,
				{
					[styles.root_selected]: isSelected
				}
			)}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
			trackingId={trackingId}
		>
			<div className={styles.header}>
				{isNotNil(icon) && (
					<div className={styles.iconWrapper}>
						<Icon value={icon} />
					</div>
				)}
				<h4 className={styles.title}>{title}</h4>
			</div>
			<div className={styles.description}>{description}</div>
		</ButtonBase>
	);
};
SelectionCard.displayName = "SelectionCard";
